import profileCvStatus from '~/dataMock/profileCvStatus'

// Stato del CV del profilo SmartCV: { status: 'none' | 'unconfirmed' | 'confirmed', file: { name, url } | null }.
// Lo usano lo step "Inoltra il CV" (variante A/B/C) e la pagina finale della candidatura (pulsante).
// MOCK SmartCV: da sostituire con il dato del profilo (stato di conferma e PDF) da get-user-data o endpoint SmartCV
export async function getProfileCvStatus () {
  return await Promise.resolve({ ...profileCvStatus })
}

// Solo lo stato, letto in modo sincrono: serve al redirect dopo il login (plugins/auth-redirect.js),
// che auth-next chiama senza attendere promesse. 'unconfirmed' comprende anche il CV in fase di parsing.
// MOCK SmartCV: da sostituire con il campo di $auth.user restituito da get-user-data
export function getProfileCvStatusSync () {
  return profileCvStatus.status
}
